import React from "react";
import logo from "./logo.svg";
import "./App.css";
import DeptFirstSearch from "./DeptFirstSearch/DeptFirstSearch";

function App() {
  return (
    <div className="App">
      <DeptFirstSearch></DeptFirstSearch>
    </div>
  );
}

export default App;
